var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_Color",
    "data-name": "\\uD83C\\uDFA8 Icon Color",
    d: "M7.561,14.634.433,8.4a1.327,1.327,0,0,1-.156-.157h0L.257,8.214l0,0L.238,8.19l0-.006L.219,8.164l0-.007L.2,8.138l0-.007-.013-.02,0-.007L.165,8.084l0-.006L.149,8.055l0,0L.133,8.027h0A1.118,1.118,0,0,1,0,7.56v0c0-.008,0-.017,0-.025s0-.012,0-.019S0,7.5,0,7.5H0c0-.01,0-.021,0-.031V7.461c0-.008,0-.016,0-.023V7.426c0-.006,0-.013,0-.019V7.392l0-.016,0-.016,0-.013,0-.018,0-.012,0-.019,0-.011,0-.019,0-.011,0-.018,0-.012,0-.017,0-.013,0-.015,0-.016,0-.013.006-.019,0-.009L.074,7.1l0-.006.011-.026h0a1.239,1.239,0,0,1,.332-.454L7.561.365a1.579,1.579,0,0,1,2.02,0,1.143,1.143,0,0,1,0,1.768L4.878,6.25H18.572A1.348,1.348,0,0,1,20,7.5a1.349,1.349,0,0,1-1.429,1.25H4.878l4.7,4.116a1.142,1.142,0,0,1,0,1.767,1.577,1.577,0,0,1-2.02,0Z",
    transform: "translate(0 0)",
    fill: "#fcfaf7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(-5 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_arrow_long",
    "data-name": "Left arrow long",
    transform: "translate(5 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_Color-2",
    "data-name": "\\uD83C\\uDFA8 Icon Color",
    d: "M7.561,14.634.433,8.4a1.327,1.327,0,0,1-.156-.157h0L.257,8.214l0,0L.238,8.19l0-.006L.219,8.164l0-.007L.2,8.138l0-.007-.013-.02,0-.007L.165,8.084l0-.006L.149,8.055l0,0L.133,8.027h0A1.118,1.118,0,0,1,0,7.56v0c0-.008,0-.017,0-.025s0-.012,0-.019S0,7.5,0,7.5H0c0-.01,0-.021,0-.031V7.461c0-.008,0-.016,0-.023V7.426c0-.006,0-.013,0-.019V7.392l0-.016,0-.016,0-.013,0-.018,0-.012,0-.019,0-.011,0-.019,0-.011,0-.018,0-.012,0-.017,0-.013,0-.015,0-.016,0-.013.006-.019,0-.009L.074,7.1l0-.006.011-.026h0a1.239,1.239,0,0,1,.332-.454L7.561.365a1.579,1.579,0,0,1,2.02,0,1.143,1.143,0,0,1,0,1.768L4.878,6.25H18.572A1.348,1.348,0,0,1,20,7.5a1.349,1.349,0,0,1-1.429,1.25H4.878l4.7,4.116a1.142,1.142,0,0,1,0,1.767,1.577,1.577,0,0,1-2.02,0Z",
    transform: "translate(0 0)",
    fill: "#fcfaf7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/nav.6383d133bf5971eea253b0a27caee19c.svg";
export { ForwardRef as ReactComponent };